'use client';
import { useEffect, useRef, useState } from 'react';
import { Button } from '@/components/shared/button';
import { twMerge } from 'tailwind-merge';
export function Modal({
  render,
  onClose,
  closeBackdrop = true,
  closeButton = true,
  label,
  title,
  modalClassName,
  modalBoxClassName,
  button,
  open: controlledOpen,
  showButton = true,
  children,
  alwaysRender = false,
  ...props
}) {
  const [ready, setReady] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof controlledOpen === 'boolean') {
      setOpen(controlledOpen);
    }
  }, [controlledOpen]);

  useEffect(() => {
    setReady(true);
  }, []);

  const dialogRef = useRef();
  const closeModal = async (flag) => {
    if (!onClose || (await onClose(flag))) {
      setOpen(false);
      if (typeof onClose === 'function') onClose(flag);
    }
  };

  useEffect(() => {
    if (open) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [open]);

  return (
    <>
      {showButton && button && button(() => setOpen(true))}
      {showButton && !button && (
        <Button
          {...props}
          onClick={() => {
            setOpen(true);
          }}
        >
          {label || children || 'Show Dialog'}
        </Button>
      )}
      <dialog
        tabIndex={open ? 0 : -1}
        className={twMerge('modal overflow-y-visible', modalClassName)}
        ref={dialogRef}
      >
        <div
          className={twMerge('modal-box overflow-y-visible', modalBoxClassName)}
        >
          {!!closeButton && (
            <button
              type="button"
              tabIndex={open ? 0 : -1}
              onClick={() => closeModal('✕')}
              className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 focus:outline-none focus-visible:outline-none focus:ring-0 focus-visible:ring-0 active:outline-none active:ring-0"
            >
              ✕
            </button>
          )}
          {!!title && <h3 className="font-bold text-lg">{title}</h3>}
          <div className={twMerge(!open && 'hidden')}>
            {!!render &&
              ready &&
              (alwaysRender || open) &&
              render({
                isOpen: open,
                close: closeModal,
                portal: dialogRef.current
              })}
          </div>
        </div>
        {!!closeBackdrop && (
          <div className="modal-backdrop">
            <button
              type="button"
              onClick={() => closeModal('backdrop')}
              tabIndex={open ? 0 : -1}
            >
              close
            </button>
          </div>
        )}
      </dialog>
    </>
  );
}
